/**
 * Nav View
 */
class NavView {

	constructor(presenter) {

		this.presenter = presenter;
		// this.navbarContent = $("#navbar-content");
		this.localisationForm = $("form.nav-localisation-form");
		this.countryIsoCodes = this.localisationForm.find("span.country-iso-code");
		this.localisationOptions = this.localisationForm.find("a.dropdown-item");
		this.localisationInput = this.localisationForm.find("input[name='country_code']").first();
		this.cartItemsBadge = $("#nav-cart-items-badge");
		this.cartItems = $("#nav-cart-items");
		this.toastMessage = $("#toast-message");

		/*
		 * Initialisation
		 */

		this.countryIsoCodes.each($.proxy(function(_index, element) {
			const codeElement = $(element);
			const code = this.presenter.getThreeLetterCode(codeElement.text());
			codeElement.text(code);
		}, this));

		/*
		 * Listeners
		 */

		this.localisationOptions.on("click", $.proxy(function(event) {

			// get the selected option, and make sure it is not what is already selected
			const isoCode = $(event.currentTarget).attr("data-country-iso-code");
			if (isoCode == this.localisationInput.val()) { return; }

			// update the option value and submit the form
			this.localisationInput.val(isoCode);
			this.localisationForm.submit();

		}, this));

	}

	/*
	 * Actions
	 */

	showMessage(message) {
		// create the new toast element and set the message
		var toast = this.toastMessage.clone();
		toast.find("div.toast-header > strong").html(message.title);
		toast.find("div.toast-body").html(message.body);
		toast.on("hidden.bs.toast", function(_event) { toast.remove(); });
		// add the toast message to the dom and show it
		this.toastMessage.before(toast);
		new bootstrap.Toast(toast.get(0), { delay: Model.TOAST_DISPLAY_DURATION * 1000 }).show();
	}

	/*
	 * Getters and Setters
	 */

	setCartItems(items) {
		if (items != null && items.length > 0) {
			this.cartItemsBadge.removeClass("d-none").addClass("d-block");
			this.cartItems.text(items.length);
		}
		else {
			this.cartItemsBadge.removeClass("d-block").addClass("d-none");
			this.cartItems.text("");
		}
	}

}